export interface WeatherCondition {
  locationName?: string;
  tempF?: number;
  weather?: string;
  icon?: string;
}

export const AerisWeatherIconMapping: Map<string, string> = new Map<string, string>([
  [ "blizzard.png", "Blizzard" ],
  [ "blizzardn.png", "Blizzard_Night" ],
  [ "blowingsnow.png", "Breezy_Snow" ],
  [ "blowingsnown.png", "Breezy_Snow" ],
  [ "clear.png", "Clear_Sunny" ],
  [ "clearn.png", "Clear_Night" ],
  [ "cloudy.png", "Mostly_Cloudy" ],
  [ "cloudyn.png", "Mostly_Cloudy_Night" ],
  [ "cloudyw.png", "Mostly_Cloudy" ],
  [ "cloudywn.png", "Mostly_Cloudy_Night" ],
  [ "cold.png", "Breezy_Snow" ],
  [ "coldn.png", "Breezy_Snow" ],
  [ "drizzle.png", "Drizzle" ],
  [ "drizzlen.png", "Drizzle_Night" ],
  [ "dust.png", "Dust" ],
  [ "dustn.png", "Dust_Night" ],
  [ "fair.png", "Clear_Sunny" ],
  [ "fairn.png", "Clear_Night" ],
  [ "drizzlef.png", "Drizzle" ],
  [ "drizzlefn.png", "Drizzle_Night" ],
  [ "fdrizzlen.png", "Drizzle_Night" ],
  [ "flurries.png", "Snow" ],
  [ "flurriesn.png", "Snow_Night" ],
  [ "flurriesw.png", "Snow" ],
  [ "flurrieswn.png", "Snow_Night" ],
  [ "fog.png", "Fog" ],
  [ "fogn.png", "Fog_Night" ],
  [ "freezingrain.png", "Sleet" ],
  [ "freezingrainn.png", "Sleet_Night" ],
  [ "hazy.png", "Haze" ],
  [ "hazyn.png", "Haze_Night" ],
  [ "hot.png", "Clear_Sunny" ],
  [ "mcloudy.png", "Mostly_Cloudy" ],
  [ "mcloudyn.png", "Mostly_Cloudy_Night" ],
  [ "mcloudyr.png", "Rain" ],
  [ "mcloudyrn.png", "Rain_Night" ],
  [ "mcloudyrw.png", "Rain" ],
  [ "mcloudyrwn.png", "Rain_Night" ],
  [ "mcloudys.png", "Snow" ],
  [ "mcloudysn.png", "Snow_Night" ],
  [ "mcloudysf.png", "Fog" ],
  [ "mcloudysfn.png", "Fog_Night" ],
  [ "mcloudysfw.png", "Snow" ],
  [ "mcloudysfwn.png", "Snow_Night" ],
  [ "mcloudysw.png", "Snow" ],
  [ "mcloudyswn.png", "Snow_Night" ],
  [ "mcloudyt.png", "Severe_Thunderstorm" ],
  [ "mcloudytn.png", "Severe_Thunderstorm_Night" ],
  [ "mcloudytw.png", "Severe_Thunderstorm" ],
  [ "mcloudytwn.png", "Severe_Thunderstorm_Night" ],
  [ "mcloudyw.png", "Windy_Breezy" ],
  [ "mcloudywn.png", "Windy_Breezy" ],
  [ "pcloudy.png", "Partly_Cloudy" ],
  [ "pcloudyn.png", "Partly_Cloudy_Night" ],
  [ "pcloudyr.png", "Scattered_Showers" ],
  [ "pcloudyrn.png", "Scattered_Showers_Night" ],
  [ "pcloudyrw.png", "Scattered_Showers" ],
  [ "pcloudyrwn.png", "Scattered_Showers_Night" ],
  [ "pcloudys.png", "Snow" ],
  [ "pcloudysn.png", "Snow_Night" ],
  [ "pcloudysf.png", "Snow" ],
  [ "pcloudysfn.png", "Snow_Night" ],
  [ "pcloudysfw.png", "Snow" ],
  [ "pcloudysfwn.png", "Snow_Night" ],
  [ "pcloudysw.png", "Snow" ],
  [ "pcloudyswn.png", "Snow_Night" ],
  [ "pcloudyt.png", "Scattered_Thunderstorm" ],
  [ "pcloudytn.png", "Scattered_Thunderstorm_Night" ],
  [ "pcloudytw.png", "Scattered_Thunderstorm" ],
  [ "pcloudytwn.png", "Scattered_Thunderstorm_Night" ],
  [ "pcloudyw.png", "Windy_Breezy" ],
  [ "pcloudywn.png", "Windy_Breezy" ],
  [ "rain.png", "Heavy_Rain" ],
  [ "rainn.png", "Heavy_Rain_Night" ],
  [ "rainandsnow.png", "Sleet" ],
  [ "rainandsnown.png", "Sleet_Night" ],
  [ "raintosnow.png", "Sleet" ],
  [ "raintosnown.png", "Sleet_Night" ],
  [ "rainw.png", "Heavy_Rain" ],
  [ "rainwn.png", "Heavy_Rain_Night" ],
  [ "showers.png", "Scattered_Showers" ],
  [ "showersn.png", "Scattered_Showers_Night" ],
  [ "showersw.png", "Scattered_Showers" ],
  [ "showerswn.png", "Scattered_Showers_Night" ],
  [ "sleet.png", "Sleet" ],
  [ "sleetn.png", "Sleet_Night" ],
  [ "sleetsnow.png", "Sleet" ],
  [ "sleetsnown.png", "Sleet_Night" ],
  [ "smoke.png", "Smoke" ],
  [ "smoken.png", "Smoke" ],
  [ "snow.png", "Snow" ],
  [ "snown.png", "Snow_Night" ],
  [ "snoww.png", "Snow" ],
  [ "snowwn.png", "Snow_Night" ],
  [ "snowshowers.png", "Snow" ],
  [ "snowshowersn.png", "Snow_Night" ],
  [ "snowshowersw.png", "Snow" ],
  [ "snowshowerswn.png", "Snow_Night" ],
  [ "snowtorain.png", "Sleet" ],
  [ "snowtorainn.png", "Sleet_Night" ],
  [ "sunny.png", "Clear_Sunny" ],
  [ "sunnyn.png", "Clear_Night" ],
  [ "sunnyw.png", "Clear_Sunny" ],
  [ "sunnywn.png", "Clear_Night" ],
  [ "tstorm.png", "Severe_Thunderstorm" ],
  [ "tstormn.png", "Severe_Thunderstorm_Night" ],
  [ "tstorms.png", "Severe_Thunderstorm" ],
  [ "tstormsn.png", "Severe_Thunderstorm_Night" ],
  [ "tstormsw.png", "Severe_Thunderstorm" ],
  [ "tstormswn.png", "Severe_Thunderstorm_Night" ],
  [ "wind.png", "Windy_Breezy" ],
  [ "windn.png", "Windy_Breezy" ],
  [ "wintrymix.png", "Sleet" ],
  [ "wintrymixn.png", "Sleet_Night" ]
]);
